import "../styles/About.css"
import { useLanguage } from "../contexts/LanguageContext";

const About = () => {
  const { language } = useLanguage();

  const content = {
    historyTitle: {
      english: "Our History & Legacy",
      tamil: "எங்கள் வரலாறு மற்றும் மரபு"
    },
    historyDescription: {
      english: "The Bharatiya Janata Party is the world's largest political party. Founded in 1980, it champions the cause of Indian culture, nationalism, and integral humanism. From a humble beginning of 2 seats in 1984 to leading the nation today, our journey is one of dedication and sacrifice.",
      tamil: "பாரதிய ஜனதா கட்சி உலகின் மிகப்பெரிய அரசியல் கட்சியாகும். 1980-ல் நிறுவப்பட்ட இக்கட்சி, இந்திய கலாச்சாரம், தேசியவாதம் மற்றும் ஒருங்கிணைந்த மனிதநேயம் ஆகியவற்றிற்காகப் போராடுகிறது. 1984-ல் 2 இருக்கைகளுடன் தொடங்கி இன்று நாட்டை வழிநடத்தும் வரை, எங்கள் பயணம் அர்ப்பணிப்பு மற்றும் தியாகத்தின் கதையாகும்."
    },
    profileTitle: {
      english: "R. Sudha RadhaKrishnan",
      tamil: "ஆர். சுதா ராதாகிருஷ்ணன்"
    },
    ideologyTitle: {
      english: "Our Ideology",
      tamil: "எங்கள் சித்தாந்தம்"
    },
    ideologydes: {
      english: "Based on the principles of Annaism and Dravidian welfare.",
      tamil: "Based on the principles of Annaism and Dravidian welfare."
    },
    leadershipTitle: {
      english: "Visionary Leadership",
      tamil: "தொலைநோக்கு தலைமை"
    },
    journeyTitle: {
      english: "Political Journey",
      tamil: "அரசியல் பயணம்"
    },
    achievementsTitle: {
      english: "Key Achievements",
      tamil: "முக்கிய சாதனைகள்"
    },
    readMore: {
      english: "Read More",
      tamil: "மேலும் வாசிக்க"
    },
    readLess: {
      english: "Read Less",
      tamil: "குறைவாக வாசிக்க"
    }
  };

  const ideologyData = [
    {
      title: {
        english: "Integral Humanism",
        tamil: "ஒருங்கிணைந்த மனிதநேயம்"
      },
      desc: {
        english: "A philosophy that places the human being at the center of development, balancing material and spiritual needs.",
        tamil: "மனிதனை மையமாக வைத்து, பொருளாதார மற்றும் ஆன்மீக தேவைகளை சமநிலைப்படுத்தும் ஒரு தத்துவம்."
      }
    },
    {
      title: {
        english: "Cultural Nationalism",
        tamil: "கலாசார தேசியம்"
      },
      desc: {
        english: "Belief that India is a cultural nation, and our unity lies in our shared heritage and values.",
        tamil: "இந்தியா ஒரு கலாசார நாடு என்ற நம்பிக்கை, நமது ஒற்றுமை நமது பகிரப்பட்ட பாரம்பரியத்திலும் மதிப்புகளிலும் உள்ளது."
      }
    },
    {
      title: {
        english: "Development Driven",
        tamil: "வளர்ச்சி சார்ந்த"
      },
      desc: {
        english: "Governance focused on infrastructure, technology, and economic empowerment for all citizens.",
        tamil: "அனைத்து குடிமக்களுக்கும் உள்கட்டமைப்பு, தொழில்நுட்பம் மற்றும் பொருளாதார அதிகாரமளிப்பில் கவனம் செலுத்தும் ஆட்சி."
      }
    }
  ];

  const leaders = [
    {
      name: {
        english: "Pt. Deendayal Upadhyaya",
        tamil: "பண்டிட். தீண்டயால் உபாத்யாயா"
      },
      role: {
        english: "Ideological Guide",
        tamil: "சித்தாந்த வழிகாட்டி"
      },
      period: "2018",
      active: false,
      img: "/assets/images/5.jpeg"
    },
    {
      name: {
        english: "Atal Bihari Vajpayee",
        tamil: "அடல் பிஹாரி வாஜ்பாய்"
      },
      role: {
        english: "First  Prime Minister",
        tamil: "முதல் பாஜக பிரதமர்"
      },
      period: "2020",
      active: false,
      img: "/assets/images/10.jpeg"
    },
    {
      name: {
        english: "Narendra Modi",
        tamil: "நரேந்திர மோடி"
      },
      role: {
        english: "Prime Minister of India",
        tamil: "இந்திய பிரதமர்"
      },
      period: "2024",
      active: true,
      img: "/assets/images/11.jpeg"
    }
  ];

  const achievements = [
    {
      title: {
        english: "Women Empowerment Leadership",
        tamil: "பெண்கள் முன்னேற்ற தலைமைத்துவம்"
      },
      subtitle: {
        english: "Guided & Trained Women Groups",
        tamil: "பெண்கள் குழுக்களுக்கு வழிகாட்டல்"
      },
      img: "/assets/cup.png"
    },
    {
      title: {
        english: "Entrepreneurship Journey",
        tamil: "தொழில்முனைவோர் பயணம்"
      },
      subtitle: {
        english: "Founder – Sanjay Bankers",
        tamil: "சஞ்சய் பேங்கர்ஸ் நிறுவனர்"
      },
      img: "/assets/cup.png"
    },
    {
      title: {
        english: "Social Service Contribution",
        tamil: "சமூக சேவை பங்களிப்பு"
      },
      subtitle: {
        english: "Helped Over 1 Lakh People",
        tamil: "ஒரு இலட்சத்திற்கும் மேற்பட்டோருக்கு உதவி"
      },
      img: "/assets/cup.png"
    },
    {
      title: {
        english: "Healthcare & Nutrition Guidance",
        tamil: "ஆரோக்கிய மற்றும் ஊட்டச்சத்து வழிகாட்டல்"
      },
      subtitle: {
        english: "Counselling & Health Awareness",
        tamil: "ஆலோசனை & விழிப்புணர்வு"
      },
      img: "/assets/cup.png"
    },
    {
      title: {
        english: "GST Implementation",
        tamil: "ஜிஎஸ்டி நடைமுறைப்படுத்தல்"
      },
      subtitle: {
        english: "Economic Reform",
        tamil: "பொருளாதார சீர்திருத்தம்"
      },
      img: "/assets/cup.png"
    },
    {
      title: {
        english: "Digital India Mission",
        tamil: "டிஜிட்டல் இந்தியா திட்டம்"
      },
      subtitle: {
        english: "Technology Advancement",
        tamil: "தொழில்நுட்ப வளர்ச்சி"
      },
      img: "/assets/cup.png"
    },
    {
      title: {
        english: "Ayushman Bharat Scheme",
        tamil: "ஆயுஷ்மான் பாரத் திட்டம்"
      },
      subtitle: {
        english: "Healthcare Support",
        tamil: "மருத்துவ சேவை"
      },
      img: "/assets/cup.png"
    },
    {
      title: {
        english: "Make in India Initiative",
        tamil: "மேக் இன் இந்தியா முயற்சி"
      },
      subtitle: {
        english: "Manufacturing Growth",
        tamil: "உற்பத்தித் துறை வளர்ச்சி"
      },
      img: "/assets/cup.png"
    },
    {
      title: {
        english: " Membership & Political Service",
        tamil: " உறுப்பினர் & அரசியல் சேவை"
      },
      subtitle: {
        english: "Active Party Member for 10+ Years",
        tamil: "10 ஆண்டுகளுக்கும் மேலான செயல்பாடு"
      },
      img: "/assets/cup.png"
    }
  ];

  const data = [
    {
      year: "1980",
      title: {
        english: "Foundation",
        tamil: "அடிப்படை"
      },
      desc: {
        english: " Formed on April 6, 1980.",
        tamil: " ஏப்ரல் 6, 1980 அன்று உருவாக்கப்பட்டது."
      }
    },
    {
      year: "1984",
      title: {
        english: "First Election",
        tamil: "முதல் தேர்தல்"
      },
      desc: {
        english: "Won 2 seats in Lok Sabha elections.",
        tamil: "மக்களவைத் தேர்தலில் 2 இடங்களை வென்றது."
      }
    },
    {
      year: "1996",
      title: {
        english: "Single Largest Party",
        tamil: "ஒற்றை பெரிய கட்சி"
      },
      desc: {
        english: "Emerges as largest party, Vajpayee becomes PM for 13 days.",
        tamil: "பெரிய கட்சியாக உருவெடுத்தது, வாஜ்பாய் 13 நாட்களுக்கு பிரதமரானார்."
      }
    },
    {
      year: "1998",
      title: {
        english: "NDA Formation",
        tamil: "NDA உருவாக்கம்"
      },
      desc: {
        english: "Formed government under Vajpayee ji's leadership.",
        tamil: "வாஜ்பாய் தலைமையில் அரசாங்கம் உருவாக்கப்பட்டது."
      }
    },
    {
      year: "2014",
      title: {
        english: "Historic Mandate",
        tamil: "வரலாற்று ஆணை"
      },
      desc: {
        english: "Full majority under PM Narendra Modi.",
        tamil: "பிரதமர் நரேந்திர மோடி தலைமையில் முழு பெரும்பான்மை."
      }
    },
    {
      year: "2019",
      title: {
        english: "Re-election",
        tamil: "மீண்டும் தேர்ந்தெடுக்கப்பட்டது"
      },
      desc: {
        english: "Returned with an even bigger mandate of 303 seats.",
        tamil: "303 இடங்கள் என மேலும் பெரிய ஆணையுடன் திரும்பியது."
      }
    }
  ];

  return (
    <div>

      <section className="about-highlight-section">
        <div className="about-highlight-container">
          {/* CONTENT */}
          <div className="about-content">
            <h1 className='abi1'>Since 1972</h1>
            <h1 className='abt2'>History of AIADMK</h1>
            <p className='abtp'>The All India Anna Dravida Munnetra Kazhagam (AIADMK) is a major political party in the Indian state of Tamil Nadu and the Union Territory of Puducherry.</p>
            <p className='abtp'>Founded by the legendary M.G. Ramachandran (MGR) on 17 October 1972 as a breakaway faction from the DMK, the party has been a dominant force in Tamil Nadu politics for over five decades.</p>
            <p className='abtp'>Under the dynamic leadership of J. Jayalalithaa, the party reached new heights, implementing revolutionary welfare schemes. Today, led by Edappadi K. Palaniswami, AIADMK continues its journey of service.</p>
          </div>
          {/* IMAGE */}
          <div className="about-image">
            {/* <h2>{content.profileTitle[language]}</h2> */}
            <img
              src="/assets/edapadi.jpg"
              alt="Profile Overview"
              loading="lazy"
            />
          </div>
        </div>
      </section>

      <section className="ideology-section">
        <h2>{content.ideologyTitle[language]}</h2>
        <p>{content.ideologydes[language]}</p>
        <div className="ideology-cards">
          {ideologyData.map((item, index) => (
            <div className="ideology-card" key={index}>
              <div className="book-icon"><img src="/assets/sudha-/book.png" alt="" /></div>
              <h4>{item.title[language]}</h4>
              <p>{item.desc[language]}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="leadership-section">
        <h2>{content.leadershipTitle[language]}</h2>
        <div className="leader-cards">
          {leaders.map((leader, i) => (
            <div
              key={i}
              className={`leader-card1 ${leader.active ? "active" : ""}`}
            >
              <div className="leader-image">
                <img src={leader.img} alt="" />
              </div>
              <div className="leader-info">
                {/* <h4>{leader.name[language]}</h4>
                <span className="role">{leader.role[language]}</span> */}
                <span className="period">{leader.period}</span>
              </div>
            </div>
          ))}
        </div>
      </section>

      <section className="journey">
        <h2>{content.journeyTitle[language]}</h2>
        <div className="timeline">
          {data.map((item, index) => (
            <div className="timeline-item" key={index}>
              <div className={`content ${index % 2 === 0 ? "left" : "right"}`}>
                <h4>{item.title[language]}</h4>
                <p>{item.desc[language]}</p>
              </div>
              {/* YEAR — ALWAYS CENTER */}
              <div className="year">{item.year}</div>
            </div>
          ))}
        </div>
      </section>

      <section className="achievement-section">
        <h2>{content.achievementsTitle[language]}</h2>
        <div className="achievement-grid">
          {achievements.map((item, i) => (
            <div className="achievement-card" key={i}>
              <div className="achievement-icon"><img src={item.img} alt="" /></div>
              <div className='achievement-text'>
                <h4>{item.title[language]}</h4>
                <span>{item.subtitle[language]}</span>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  )
}

export default About